/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%]{position:absolute;top:0;right:0;background-color:transparent;border-color:transparent;color:rgba(0,0,0,.54);font-size:1.2em!important}textarea[_ngcontent-%COMP%]{overflow:hidden!important;resize:none!important}"];
export { styles as styles };
